<template>
  <div class="wrapper">
    <div class="header_wrapper">
      <v-toolbar color="primary" style="position: relative;">
        <v-btn @click="routerBack" icon="mdi-chevron-left" variant="text"></v-btn>

        <v-toolbar-title
          style="
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            margin: 0;
            padding: 0;
            max-width: 70%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            color: white;
          "
          class="text-center"
        >
          {{ me ? me.lastName + me.firstName : '' }}
        </v-toolbar-title>

        <div style="width: 70px; margin-left: auto;">
          <v-btn
            @click="put"
            :loading="btnLoading"
            variant="text"
            class="no-background-hover font-weight-bold text-white"
          >
            {{ t('parentEdit.save') }}
          </v-btn>
        </div>
      </v-toolbar>
    </div>

    <div v-if="loading" class="d-flex align-center height100">
      <vue-loading
        type="bars"
        color="#EE6090"
        :size="{ width: '50px', height: '50px' }"
      ></vue-loading>
    </div>

    <v-form v-else ref="put_me_form" class="px-2 py-3">
      <div class="d-flex justify-center mb-5">
        <div v-show="pickedImg" class="picked_img" @click="pickFile">
          <img :src="pickedImg || undefined" />
        </div>
        <div
          v-show="!pickedImg"
          class="file_uploader pa-3"
          :class="[{ '-drag': isDrag == 'new' }]"
          @click="pickFile"
          @dragover.prevent="checkDrag($event, 'new', true)"
          @dragleave.prevent="checkDrag($event, 'new', false)"
          @drop.prevent="onDrop"
        >
          <input
            class="d-none"
            id="file-input"
            ref="fileInput"
            type="file"
            @change="onDrop"
            accept=".png,.jpg,image/jpeg,image/png"
          />
        </div>
      </div>

      <div class="d-flex">
        <div style="width: 50%;" class="pr-1">
          <p class="text-body-2 text-blue-grey">{{ t('parentEdit.lastName') }}</p>
          <v-text-field v-model="lastName" variant="outlined" density="compact" :rules="[rules.required]"></v-text-field>
        </div>

        <div style="width: 50%;" class="pr-1">
          <p class="text-body-2 text-blue-grey">{{ t('parentEdit.firstName') }}</p>
          <v-text-field v-model="firstName" variant="outlined" density="compact" :rules="[rules.required]"></v-text-field>
        </div>
      </div>

      <div v-if="false" class="d-flex mt-2">
        <div style="width: 50%;" class="pr-1">
          <p class="text-body-2 text-blue-grey">{{ t('parentEdit.lastNameKana') }}</p>
          <v-text-field
            v-model="lastNameKana"
            variant="outlined"
            density="compact"
          ></v-text-field>
        </div>

        <div style="width: 50%;" class="pr-1">
          <p class="text-body-2 text-blue-grey">{{ t('parentEdit.firstNameKana') }}</p>
          <v-text-field
            v-model="firstNameKana"
            variant="outlined"
            density="compact"
          ></v-text-field>
        </div>
      </div>
    </v-form>

    <div class="btn-delete d-flex justify-center align-center py-2">
      <v-btn
        @click="isDeleteDialog = true"
        variant="text"
        color="error"
        class="font-weight-bold"
      >
        {{ t('parentEdit.deleteAccount') }}
      </v-btn>
      
      <v-dialog v-model="isDeleteDialog" max-width="500">
        <delete-modal
          :isOpen="isDeleteDialog"
          @close="isDeleteDialog = false" 
          @del="del"
        />
      </v-dialog>
    </div>
  </div>
</template>

<script lang="ts">
// ⭕️ 修正3: Vue 3では不要な `import Vue from 'vue';` を削除
import { defineComponent } from 'vue';
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
dayjs.locale('ja');
import { Toast } from '@/service/SweetAlert';
import rules from '@/service/ValidRules';

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';

import { meModule } from '@/store/entityModules/me';
import { familyModule } from '@/store/entityModules/family';
import { resourceModule } from '@/store/entityModules/resource';

import DeleteModal from '@/components/modal/DeleteModal.vue';
import parentTypes from '@/service/parentTypes';
import { t } from '@/i18n';

import type { VForm } from 'vuetify/components';
import { ParentResponse } from 'chaild-entity/lib';

interface DataType {
  birthDate: string | null;
  isBirthPicker: boolean;
  imageFile: File | null;
  pickedImg: string;
  isDrag: string;
  bloodTypeOptions: Array<{ text: string; value: string | null }>;
  firstName: string | null;
  lastName: string | null;
  firstNameKana: string | null;
  lastNameKana: string | null;
  imageUrl: string | null;
  birth: string | null;
  bloodType: string | null;
  tel: string | null;
  parentType: string;
  btnLoading: boolean;
  loading: boolean;
  isDeleteDialog: boolean;
  isNewinfo: boolean;
}

export default defineComponent({
  components: {
    'vue-loading': Loading,
    DeleteModal,
  },

  computed: {
    rules() {
      return rules;
    },
    form(): VForm {
      return (this.$refs as any).put_me_form;
    },
    me() {
      return meModule.me;
    },
    family() {
      return familyModule.family;
    },
    parentInfo(): ParentResponse | null {
      if (this.me && this.family) {
        const index = this.family.parents.findIndex((p) => {
          if (this.me && p.parentId === this.me.parentId) {
            return true;
          }
        });
        const f = this.family.parents[index];
        return f || null;
      }
      return null;
    },
    parentTypes() {
      return parentTypes;
    },
    bloodTypeOptions(): Array<{ text: string; value: string | null }> {
      return [
        { text: this.t('parentEdit.bloodType.a'), value: 'a' },
        { text: this.t('parentEdit.bloodType.b'), value: 'b' },
        { text: this.t('parentEdit.bloodType.o'), value: 'o' },
        { text: this.t('parentEdit.bloodType.ab'), value: 'ab' },
        { text: this.t('parentEdit.bloodType.unknown'), value: null },
      ];
    },
  },

  data: (): DataType => ({
    birthDate: null,
    isBirthPicker: false,
    imageFile: null,
    pickedImg: '',
    isDrag: '',
    bloodTypeOptions: [] as Array<{ text: string; value: string | null }>,
    firstName: '',
    lastName: '',
    firstNameKana: null,
    lastNameKana: null,
    imageUrl: null,
    birth: null,
    bloodType: null,
    tel: null,
    parentType: '',
    btnLoading: false,
    loading: false,
    isDeleteDialog: false,
    isNewinfo: false,
  }),

  methods: {
    t,
    routerBack() {
      this.$router.replace('/setting/family');
    },
    pickFile() {
      const fileInput = this.$refs.fileInput as HTMLInputElement;
      fileInput.click();
    },
    checkDrag(event: any, key: string, status: boolean) {
      if (status && event.dataTransfer.types.includes('text/plain')) {
        return false;
      }
      this.isDrag = status ? key : '';
    },
    async onDrop(event: any) {
      this.isDrag = '';
      const fileList = event.target.files ? event.target.files : event.dataTransfer.files;
      if (fileList.length === 0) return false;
      
      const file = fileList[0];
      const fr = new FileReader();
      fr.readAsDataURL(file);
      fr.addEventListener('load', () => {
        this.pickedImg = fr.result as string;
      });
      
      const response = await resourceModule.postResource({
        imageType: 'profile',
        contentType: file.type, 
        file,
        childId: null,
      });
      if (response) {
        const url = response.split('?')[0];
        this.imageUrl = url;
        this.imageFile = file;
      }
    },
    async putMe() {
      const { valid } = await this.form.validate();
      if (valid) {
        try {
          const response = await meModule.putMe({
            firstName: this.firstName,
            lastName: this.lastName,
            firstNameKana: this.firstNameKana,
            lastNameKana: this.lastNameKana,
            imageUrl: this.imageUrl,
            birth: this.birth,
            bloodType: this.bloodType,
            tel: this.tel,
            notifications: [],
            isNewinfo: this.isNewinfo,
          });
          return response;
        } catch (error) {
          return false;
        }
      }
      return false;
    },
    async delMe() {
      try {
        const response = await meModule.delMe({
          notifications: [],
        });
        return response;
      } catch (error) {
        return false;
      }
    },
    async putFamilyById() {
      const { valid } = await this.form.validate();
      if (valid && this.family) {
        const editedParent = {
          parentId: '',
          parentType: this.parentType,
        };
        if (this.parentInfo) {
          editedParent.parentId = String(this.parentInfo.parentId);
        }
        try {
          const response = await familyModule.putFamilyById({
            familyId: String(this.family.familyId),
            parents: [editedParent],
          });
          return response;
        } catch (error) {
          return false;
        }
      }
      return false;
    },
    async del(){
      try {
        await Promise.all([this.delMe(), this.putFamilyById()]);
      } catch (error) {
        console.warn(error);
      }
    },
    async put() {
      this.btnLoading = true;
      const { valid } = await this.form.validate();
      if (valid) {
        try {
          await Promise.all([this.putMe(), this.putFamilyById()]);
          Toast.fire({
            icon: 'success',
            title: this.t('parentEdit.successMessage'),
          });
        } catch (error) {
          console.warn(error);
        }
      }
      this.btnLoading = false;
    },
  },

  async mounted() {
    this.loading = true;
    const familyId = this.me?.families?.[0]?.familyId;
    if (familyId) {
      await familyModule.fetchFamilyById({ familyId });
    }
    
    if (this.me) {
      this.firstName = this.me.firstName;
      this.lastName = this.me.lastName;
      this.firstNameKana = this.me.firstNameKana;
      this.lastNameKana = this.me.lastNameKana;
      this.imageUrl = this.me.imageUrl;
      this.pickedImg = this.me.imageUrl || '';
      this.birth = this.me.birth;
      this.bloodType = this.me.bloodType;
      this.tel = this.me.tel;
      this.isNewinfo = this.me.isNewinfo;
    }
    if (this.me && this.family && this.parentInfo) {
      this.parentType = this.parentInfo.parentType;
    }
    this.loading = false;
  },
});
</script>

<style lang="scss" scoped>
.wrapper {
  padding-top: calc(var(--app-top-offset) + 56px);
  padding-bottom: calc(env(safe-area-inset-bottom) + 80px); 
}

/* ===== ヘッダー ===== */
.header_wrapper {
  width: 100%;
  position: fixed;
  top: var(--app-top-offset);
  left: 0;
  z-index: 100;
}

/* ===== 画像アップローダー ===== */
.picked_img, .file_uploader {
  height: 100px;
  width: 100px;
  background-color: #f5f5f5;
  border-radius: 50%; /* 100% ではなく 50% が標準的です */
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #e0e0e0;
}

.picked_img img {
  object-fit: cover;
  border-radius: 50%;
  height: 100%;
  width: 100%;
}

.btn-delete {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: #ffffff;
  z-index: 50;
  border-top: 1px solid #e0e0e0;
  padding-bottom: env(safe-area-inset-bottom); /* iOS ホームバー対応 */
}
</style>